import api from '@/apis/dvc/dVCFileC202API.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('dVCFileC202', api);

const state = {
  ...crud.state,
  _config: {
    table: 'dvc_file_c202',
    field: {
      key: 'dvc_file_c202_id',
      //   code: 'file_code'
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
